export const isLoyaltyId = inputValue => /^\d+$/.test(inputValue);

export const sortTargetedOffers = (targetedOffers, TOapplied) => {
  const targetedOffersSorted = [];
  const TOClone = [...targetedOffers];
  const offerAppliedIndex = TOClone.findIndex(
    offer => offer.campaignId == TOapplied.campaignId,
  );

  if (offerAppliedIndex != -1) {
    const [offerApplied] = TOClone.splice(offerAppliedIndex, 1);
    targetedOffersSorted.push(offerApplied);
  }

  TOClone.sort(
    (offerA, offerB) => new Date(offerA.endDate) - new Date(offerB.endDate),
  );
  targetedOffersSorted.push(...TOClone);

  return targetedOffersSorted;
};
